import { ArrowBottomRightIcon, ArrowTopRightIcon } from "@radix-ui/react-icons";
import { useEffect } from "react";
import { NoData } from "@/components/NoData";
import { Spinner } from "@/components/Spinner";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { UseData } from "./UseData";

export const Signals = () => {
	const { isLoading, error, data, execute } = UseData.create().useGetData();

	useEffect(() => {
		try {
			execute();
		} catch {}
	}, [execute]);

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : error ? (
				<NoData />
			) : (
				<>
					<Card className="w-full">
						<CardContent className="space-y-4 pt-4">
							<span className="block text-sm font-semibold">What Stock?</span>
							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">Earning Momentum</h4>
								<div className="justify-self-end">
									{data?.hasEarningMomentum ? (
										<Badge variant="down">No</Badge>
									) : (
										<Badge variant="up">Yes</Badge>
									)}
								</div>
							</div>

							<div className="grid grid-cols-2 items-center">
								<div>
									<h4 className="text-primary font-medium">EM Score</h4>
									<p className="text-sm">(EM≥20)</p>
								</div>
							</div>

							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">EM Bias</h4>
								<div className="justify-self-end">
									{data?.positiveEmBias ? (
										<ArrowTopRightIcon className="text-epsm-up w-8 h-8" />
									) : (
										<ArrowBottomRightIcon className="text-epsm-down w-8 h-8" />
									)}
								</div>
							</div>
						</CardContent>
					</Card>

					<Card className="w-full">
						<CardContent className="space-y-4 pt-4">
							<span className="block text-sm font-semibold">When?</span>
							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">Timing Momentum</h4>
								<div className="justify-self-end">
									{data?.isTimingMomentumNow &&
									data?.positiveTmBias &&
									data?.isOutperformingMarket ? (
										<Badge variant="up">Yes</Badge>
									) : (
										<Badge variant="down">No</Badge>
									)}
								</div>
							</div>

							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">
									Timing Momentum Score
								</h4>
								<div className="justify-self-end">
									{data?.isTimingMomentumNow ? (
										<ArrowTopRightIcon className="text-epsm-up w-7 h-7" />
									) : (
										<ArrowBottomRightIcon className="text-epsm-down w-7 h-7" />
									)}
								</div>
							</div>

							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">TM Bias</h4>
								<div className="justify-self-end">
									{data?.positiveTmBias ? (
										<ArrowTopRightIcon className="text-epsm-up w-7 h-7" />
									) : (
										<ArrowBottomRightIcon className="text-epsm-down w-7 h-7" />
									)}
								</div>
							</div>

							<div className="grid grid-cols-2 items-center">
								<h4 className="text-primary font-medium">Market Score</h4>
								<div className="justify-self-end">
									{data?.isOutperformingMarket ? (
										<ArrowTopRightIcon className="text-epsm-up w-7 h-7" />
									) : (
										<ArrowBottomRightIcon className="text-epsm-down w-7 h-7" />
									)}
								</div>
							</div>
						</CardContent>
					</Card>

					<Card className="w-full">
						<CardContent className="grid grid-cols-2 items-center">
							<div className="pt-4">
								<h4 className="text-primary font-medium">S&P Trend (SPY)</h4>
								<p>MA 5week &gt; MA 20week</p>
							</div>
							<div className="justify-self-end">
								{data?.isSnpTrend ? (
									<ArrowTopRightIcon className="text-epsm-up w-7 h-7" />
								) : (
									<ArrowBottomRightIcon className="text-epsm-down w-7 h-7" />
								)}
							</div>
						</CardContent>
					</Card>
				</>
			)}
		</>
	);
};
